import { render } from "./FormSectionTitleComponent.vue?vue&type=template&id=79f7b3fe"
import script from "./FormSectionTitleComponent.vue?vue&type=script&lang=js"
export * from "./FormSectionTitleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__